import { testIsObject } from '../../lib/test-and-assert/test-base';

class AuthFormValidatorHelper {
    constructor(config) {
        this.config = {
            minPasswordLength: 3,
            maxPasswordLength: 256,
        };

        if (testIsObject(config)) {
            this.config = config;
        }
    }

    /**
     * Hides error message
     */
    resetFieldError($fieldContainer, $errorContainer) {
        $fieldContainer.removeClass('has-error');
        $errorContainer.addClass('hidden');
    }

    /**
     * Returns false if field is empty and displays error message
     */
    processFieldEmpty($field, $fieldContainer, $errorContainer, errorMessage) {
        if ($field.val().trim() === '') {
            $fieldContainer.addClass('has-error');
            $errorContainer.removeClass('hidden').find('span').html(errorMessage);

            return false;
        }

        return true;
    }

    /**
     * Returns false if fields don't match and displays error message for first field
     */
    processFieldsMismatch(fields, $fieldContainer, $errorContainer, errorMessage) {
        if (fields.$fieldOne.val().trim() !== fields.$fieldTwo.val().trim()) {
            $fieldContainer.addClass('has-error');
            $errorContainer.removeClass('hidden').find('span').html(errorMessage);

            return false;
        }

        return true;
    }

    /**
     * Returns false if email is invalid and displays error message
     */
    processEmailInvalid($emailField, $emailFieldContainer, $errorContainer, errorMessage) {
        var emailReg = /.*\@.*\..*/;
        if (!emailReg.test($emailField.val().trim())) {
            $emailFieldContainer.addClass('has-error');
            $errorContainer.removeClass('hidden').find('span').html(errorMessage);

            return false;
        }

        return true;
    }

    /**
     * Returns false if password is too short and displays error message
     */
    processPasswordTooShort($pwField, $pwFieldContainer, $errorContainer, errorMessage) {
        if ($pwField.val().length < this.config.minPasswordLength) {
            $pwFieldContainer.addClass('has-error');
            $errorContainer.removeClass('hidden').find('span').html(errorMessage);

            return false;
        }

        return true;
    }

    processPasswordTooLong($pwField, $pwFieldContainer, $errorContainer, errorMessage) {
        if ($pwField.val().length > this.config.maxPasswordLength) {
            $pwFieldContainer.addClass('has-error');
            $errorContainer.removeClass('hidden').find('span').html(errorMessage);

            return false;
        }

        return true;
    }

    /**
     * Returns false if password contains invalid characters and displays error message
     */
    processPasswordInvalid($pwField, $pwFieldContainer, $errorContainer, errorMessage) {
        var pwRegex = /(^\s|\s$)/;
        if (pwRegex.test($pwField.val())) {
            $pwFieldContainer.addClass('has-error');
            $errorContainer.removeClass('hidden').find('span').html(errorMessage);

            return false;
        }

        return true;
    }

    /**
     * Returns false if checkbox is unchecked and displays error message
     */
    processCheckboxChecked($checkbox, $checkboxContainer, $errorContainer, errorMessage) {
        if ($checkbox.is(':checked') === false) {
            $checkboxContainer.addClass('has-error');
            $errorContainer.removeClass('hidden').find('span').html(errorMessage);

            return false;
        }

        return true;
    }
}

export { AuthFormValidatorHelper };
